/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "testId"];
import "./loading-container-advanced.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
/* eslint-disable @repo/internal/react/require-jsdoc */

import { forwardRef } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var containerStyles = null;
export var Container = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
    testId = props.testId,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    "data-testid": testId,
    ref: ref,
    className: ax(["_kqswh2mm _6rth1ejb"])
  }), children);
});
var spinnerBackdropStyles = null;
export var SpinnerBackdrop = function SpinnerBackdrop(_ref) {
  var children = _ref.children,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testId && "".concat(testId, "--spinner-backdrop"),
    className: ax(["_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"])
  }, children);
};
var spinnerContainerStyles = null;
export var SpinnerContainer = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: ax(["_kqswh2mm _152tidpf"])
  }, children);
});